import React from "react";
import {
  Grid,
  TextField,
  Checkbox,
  FormControlLabel,
  Divider,
  Typography,
} from "@mui/material";
import ClientAttachmentsTable from "./ClientAttachmentsTable";

const CHECKBOX_FIELDS = [
  { name: "taxable", label: "Taxable" },
  { name: "shortTerm", label: "Short Term" },
  { name: "hold", label: "Hold" },
  { name: "isDeleted", label: "Is Deleted" },
  { name: "reportToLocalAgency", label: "Report to Local Agency" },
  { name: "reportToFederalAgency", label: "Report to Federal Agency" },
  { name: "sendToRegulatory", label: "Send to Regulatory" },
  { name: "emailRegulatoryOnly", label: "Email Regulatory Only" },
  { name: "carbonCopy", label: "Carbon Copy" },
  { name: "faxReport", label: "Fax Report" },
  { name: "printBit", label: "Print Bit" },
  { name: "emailBit", label: "Email Bit" },
  { name: "eomBit", label: "EOM Bit" },
  { name: "eowBit", label: "EOW Bit" },
  { name: "surchargeExempt", label: "Surcharge Exempt" },
  { name: "newAccountExempt", label: "New Account Exempt" },
  { name: "grantaccesstoallusers", label: "Grant Access to All Users" },
  { name: "enableSampleReceipt", label: "Enable Sample Receipt" },
  { name: "shouldReceiveCoC", label: "Should Receive CoC" },
];

const NotesSettingsStep = ({ formData, handleChange, accountNumber }) => {
  return (
    <Grid container spacing={2.5}>
      <Grid item xs={12} md={6}>
        <TextField label="Client Notes" name="clientNotes" value={formData.clientNotes} onChange={handleChange} fullWidth size="small" multiline rows={3} />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField label="Special Instructions" name="specialInstructions" value={formData.specialInstructions} onChange={handleChange} fullWidth size="small" multiline rows={3} />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField label="Hold Comments" name="holdComments" value={formData.holdComments} onChange={handleChange} fullWidth size="small" multiline rows={2} />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField label="Compliance Notes" name="complianceNotes" value={formData.complianceNotes} onChange={handleChange} fullWidth size="small" multiline rows={2} />
      </Grid>
      <Grid item xs={12}>
        <TextField label="Billing Email Text" name="billingEmailText" value={formData.billingEmailText} onChange={handleChange} fullWidth size="small" multiline rows={2} />
      </Grid>

      <Grid item xs={12}>
        <Divider sx={{ my: 1 }} />
        <Typography variant="subtitle1" color="primary" sx={{ mb: 1.5, fontWeight: 600 }}>
          Settings & Preferences
        </Typography>
        <Grid container spacing={0}>
          {CHECKBOX_FIELDS.map(({ name, label }) => (
            <Grid item xs={12} sm={6} md={3} key={name}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData[name]}
                    onChange={handleChange}
                    name={name}
                    size="small"
                  />
                }
                label={label}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>

      {/* ENB-602: attachments need an existing account, so they are hidden on Add New. */}
      {accountNumber && accountNumber !== "add-new" && (
        <Grid item xs={12}>
          <Divider sx={{ my: 1 }} />
          <Typography variant="subtitle1" color="primary" sx={{ mb: 1.5, fontWeight: 600 }}>
            Attachments
          </Typography>
          <ClientAttachmentsTable accountNumber={accountNumber} />
        </Grid>
      )}
    </Grid>
  );
};

export default NotesSettingsStep;
